import { render, staticRenderFns } from "./SmartAssistant.vue?vue&type=template&id=0d65961f&scoped=true&"
import script from "./SmartAssistant.vue?vue&type=script&lang=js&"
export * from "./SmartAssistant.vue?vue&type=script&lang=js&"
import style0 from "./SmartAssistant.vue?vue&type=style&index=0&id=0d65961f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d65961f",
  null
  
)

export default component.exports